import { createFileRoute, notFound } from "@tanstack/react-router";

import { CREATE_CLIENT_ROUTE_SLUG } from "../../app/constants";
import { CreateClientPage } from "../../pages/dashboard/create-client/CreateClient.page";

export const Route = createFileRoute("/_protected/dashboard/$createClientSlug")({
  beforeLoad: ({ params }) => {
    if (params.createClientSlug !== CREATE_CLIENT_ROUTE_SLUG) {
      throw notFound();
    }
  },
  component: CreateClientPage,
});
